module.exports = __webpack_public_path__ + "static/media/072-bonaire.d9f7944e.svg";